export const MetaTrackerEvents = {
  PresentationRequest: 'Lead',
  Registered: 'Registered',
};
